import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate, useParams } from 'react-router-dom';
import { EntityList, PageHead } from '../../components/EntityList';
import PaymentEditor from './PaymentEditor';

function NewPaymentNew() {
	const { id } = useParams();
	const navigate = useNavigate();
	const returnTo = `/AdminScreen/debts/debt/${id}/cobros`;

	return (
		<EntityList>
			<Helmet>
				<title>Agregar Cobro</title>
			</Helmet>
			<PageHead
				breadcrumb={[
					{ label: 'Inicio', to: '/AdminScreen' },
					{ label: 'Deudas', to: '/AdminScreen/debts' },
					{ label: 'Agregar Cobro' },
				]}
				title='Agregar Cobro'
				subtitle='Completá los datos para registrar el cobro.'
			/>
			<PaymentEditor
				mode='create'
				preloadDebtId={id}
				onCancel={() => navigate(returnTo)}
				onSaved={() => navigate(returnTo)}
				saveLabel='Agregar'
			/>
		</EntityList>
	);
}

export default NewPaymentNew;
